import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import { configureAPI } from '@/services/api';
import TextInput from './components/forms/TextInput.vue';
import FileInput from './components/forms/FileInput.vue';
import ToggleInput from './components/forms/ToggleInput.vue';
import SimpleTable from './components/tables/SimpleTable.vue';
import Multiselect from 'vue-multiselect';
import SVGIcon from './components/common/SVGIcon.vue';
import Tooltip from './components/common/Tooltip.vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

import './assets/sass/app.scss';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'toastify-js/src/toastify.css';

if(process.env.VUE_APP_ENV === 'production') {
  //@ts-ignore
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';// @ts-ignore
    // @ts-ignore
    j.async=true;
    // @ts-ignore
    j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;// @ts-ignore
    // @ts-ignore
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-5CCS3FN');

  Sentry.init({
    dsn: 'https://8d464c552b5c40a28e17e569456c04e7@o226330.ingest.sentry.io/5356881',
    integrations: [new VueIntegration({Vue, attachProps: true})],
  });
}

Vue.config.productionTip = false;

Vue.use(VueMeta);

Vue.component('TextInput', TextInput);
Vue.component('FileInput', FileInput);
Vue.component('Multiselect', Multiselect);
Vue.component('ToggleInput', ToggleInput);
Vue.component('SimpleTable', SimpleTable);
Vue.component('SVGIcon', SVGIcon);
Vue.component('Tooltip', Tooltip);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
